<script>
import tooltip from "./Tooltip.vue";
export default {
  components: { tooltip },
  data() {
    return {
      toggleTooltip: false,
    };
  },
};
</script>
<template>
  <div class="certification-content">
    <i class="bx bxs-certification checked"
    
    @mouseover="toggleTooltip = true"
      @mouseout="toggleTooltip = false"
    ></i>
    <Transition>
      <tooltip v-if="toggleTooltip" setTitle="Verificado" />
    </Transition>
  </div>
</template>

<style scoped>
.bxs-certification.checked {
  font-size: 20px;
  position: relative;
}

.bxs-certification.checked::after {
  content: "\ea41";
  color: var(--white);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}

.certification-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>